import { createAsyncThunk } from '@reduxjs/toolkit';
import { AuditLogEntry } from '@utils/auditLog.ts';
import { PaginateResponse } from '@utils/appUtils.ts';
import { auditLogService } from '@core/services/auditLog.service.ts';

export const loadAuditLogs = createAsyncThunk<
  PaginateResponse<AuditLogEntry>,
  {
    page: number;
    size: number;
    action?: string;
    username?: string;
    from?: string;
    to?: string;
  }
>('auditLog/load', async ({ page, size, action, username, from, to }) => {
  return auditLogService.findAll({ page, size, action, username, from, to });
});
